// @flow
import * as React from 'react';
import './body-categories.scss'
import {ListNominations} from "./list-nominations";
import {Nomination} from "./list-item";

type Props = {
  currentCategory: number;
  nominations: Nomination[];
  setCategory: (category: number) => void
  setAlertServiceValues: Function
  setShow: Function
};

export const BodyCategories = (
{
  nominations,
  currentCategory, 
  setCategory,
  setAlertServiceValues,
  setShow
}: Props) => {
  return (
    <div className={"categories container"}>
      <ListNominations
        setAlertServiceValues={setAlertServiceValues}
        setShow={setShow}
        nominations={nominations}
        setCategory={setCategory}
        currentCategory={currentCategory} />
    </div>
  );
};
